import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { Col } from '@zendeskgarden/react-grid';
import { wave } from 'utility/customAnimations';

const {
  color_grey_200: colorGrey200,
  custom_blue: customBlue,
  color_white: colorWhite,
  color_black: colorBlack,
  custom_dark_grey: customDarkGrey,
} = variables;

export const Status = styled('div')`
  padding-top: 1rem;
  margin-left: 1rem;
  @media (max-width: 970px) {
    margin-left: 3rem;
  }
`;

export const Header = styled('div')`
  position: relative;
  display: flex;
`;

export const PercentageDiv = styled('div')`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  background: ${colorWhite};
  color: ${(props) => (props.percentage >= 60 ? colorWhite : colorBlack)};
  .percentage_div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 0.05rem solid ${customBlue};
    height: 3.1rem;
    width: 3.1rem;
    overflow: hidden;
    border-radius: 1.5rem;
    box-shadow: 1px 1px 7px -2px ${customDarkGrey};
    background: ${(props) =>
      props.percentage >= 60 ? customBlue : colorWhite};
  }
  .percentage_div::before {
    content: '';
    font-size: 0.8rem;
    background: ${customBlue};
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .percentage_div::after {
    content: '';
    position: absolute;
    bottom: 20%;
    left: -20%;
    height: 160%;
    width: 160%;
    background: ${(props) =>
      props.percentage >= 60 ? colorWhite : customBlue};
    border-radius: 35%;
    animation: ${(props) => wave(props.percentage)} 4s ease-in-out forwards;
  }
`;

export const InspectionScope = styled(Col)`
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  ${(props) => (props.noStart ? 'margin-top: 20px;' : null)};
  .scopeList {
    width: 100%;
    display: ${(props) => (props.noStart ? 'flex' : 'grid')};
    height: ${(props) => (props.noStart ? 'fit-content' : null)};
    margin-top: 10px;
    @media (max-width: 660px) {
      justify-content: center;
    }
    @media (max-width: 456px) {
      margin-top: 0;
    }
  }
  .scopeMoreInfo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    width: 95%;
    font-weight: 600;
    text-align: center;
    @media (max-width: 933px) {
      margin-top: -20px;
      width: 100%;
    }
    @media (max-width: 780px) {
      bottom: -18px;
      width: 80%;
    }
    @media (max-width: 768px) {
      display: flex;
      align-items: center;
    }
    @media (max-width: 541px) {
      width: 90%;
    }
    @media (max-width: 455px) {
      bottom: -20px;
      flex-wrap: wrap;
      flex-direction: column;
    }
  }
  .inspectionList {
    padding: 10px 40px;
    display: flex;
    flex-wrap: nowrap;
    @media (max-width: 1277px) {
      padding: 8px 20px;
    }
    @media (max-width: 1158px) {
      padding: 10px 20px;
      max-height: 150px;
    }
    @media (max-width: 1116px) {
      padding: 10px 5px;
      margin-bottom: 5px;
    }
    @media (max-width: 455px) {
      padding: 10px;
    }
  }
  .percentageBubble {
    font-size: 14px;
    display: flex;
    align-self: flex-start;
    justify-content: flex-start;
    padding-right: 1em;
    @media (max-width: 1024px) {
      padding-right: 5em;
    }
    @media (max-width: 767px) {
      display: flex;
      justify-content: center;
    }
    @media (max-width: 660px) {
      max-width: 50px;
      padding-right: 2em;
    }
  }
  .listItems {
    margin-left: 0px;
  }
  .inspectionScopeItems {
    font-size: 1.2em;
    font-weight: 400;
    padding-top: 0.15em;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    @media (max-width: 1050px) {
      font-size: 1em;
      line-height: 1em;
    }
  }
  .inspectionCheckMark {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
  }
  #submitInquiry {
    border: none;
    padding: 0;
    color: ${customBlue};
    min-width: 0;
    padding-bottom: 1px;
    virtical-align: baseline;
    &:hover {
      background-color: white;
    }
  }
  @media (max-width: 1279px) {
    margin-left: 0;
  }
  @media (max-width: 780px) {
    height: 220px;
    margin-left: ${(props) => (props.noStart ? '0' : '20px')};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const NoStartMessage = styled('div')`
  background-color: ${colorGrey200};
  border-radius: 20px;
  width: 93%;
  height: 60%;
  padding: 20px;
  display: flex;
  align-self: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: 20px;
  @media (max-width: 992px) {
    height: 70%;
  }
  @media (max-width: 768px) {
    height: 90%;
  }
`;
